import { Link } from "@/i18n/navigation";
import { useTranslations } from "next-intl";
import { useState } from "react";

interface NavigationFiltersProps {
  items: {
    label: string;
    doNotTranslate?: boolean;
    active: boolean;
    path?: string;
    onClick?: () => void;
    imageUrl?: string;
    imageClassNames?: string;
  }[];
  translationCollection: string;
}

function NavigationFilters(props: NavigationFiltersProps) {
  const t = useTranslations(props.translationCollection);
  const [mobileIsOpen, setMobileIsOpen] = useState<boolean>(false);

  const collapseClasses = {
    "open": "collapse-open",
    "close": "collapse-close",
  }

  const filtersContent = props.items.map((item, index) => {
    if (item.path) {
      return (
        <Link key={`filter-link-${index}`} href={item.path}>
          <button className={"btn btn-sm md:btn-md rounded-full gap-2" + (item.active ? " btn-secondary text-white" : "")}>
            {item.imageUrl && (
              <img src={item.imageUrl} className={item.imageClassNames || "w-[22px] h-[22px]"} />
            )}
            {item.doNotTranslate ? item.label : t(item.label)}
          </button>
        </Link>
      )
    } else {
      return (
        <button key={`filter-link-${index}`} className={"btn btn-sm md:btn-md rounded-full gap-2" + (item.active ? " btn-secondary text-white" : "")} onClick={item.onClick}>
          {item.imageUrl && (
            <img src={item.imageUrl} className={item.imageClassNames || "w-[22px] h-[22px]"} />
          )}
          {item.doNotTranslate ? item.label : t(item.label)}
        </button>
      )
    }
  })

  return (
    <>
      <div className="p-2.5 gap-2.5 hidden md:flex flex-row flex-wrap">
        {filtersContent}
      </div>
      <div tabIndex={0} className={`md:hidden collapse collapse-arrow bg-base-100 border-base-300 border ${mobileIsOpen ? collapseClasses.open : collapseClasses.close}`}>
        <div className="collapse-title text-sm font-semibold" onClick={() => setMobileIsOpen(!mobileIsOpen)}>Filter</div>
        <div className="collapse-content px-1 gap-2 text-sm flex flex-row flex-wrap">
          {filtersContent}
        </div>
      </div>
    </>
  );
}

export default NavigationFilters;
